<app-navbar></app-navbar>
<!--Page Header-->
<div id="page-head" class="mb-10">
    <div class="container mx-auto">
        <h1>Refund Policy</h1>
    </div>
</div>
<!--Page Content-->
<section class="w-full min-h-screen mt-10">
    <div class="container mx-auto">
        <div class="flex flex-wrap">
            <div class="w-full lg:w-1/3">
              <img src="./assets/images/refund-image.png" class="w-full">
            </div>
            <div class="w-full lg:w-2/3">
               
            </div>           
        </div>
    </div>
</section>
<app-message></app-message>
<app-footer></app-footer>